export default __webpack_public_path__ + "./assets/product-feature__871d2a08fc4e5cc1bf44caff38ccb836.png";